import Page from "components/Page";
import { Props } from "./Currencies";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const Currencies = lazyWithRetry(() => import("./Currencies"));

export default (props: Props) => (
  <Page>
    <Currencies {...props} />
  </Page>
);
